import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiExternalLink, FiChevronRight } from 'react-icons/fi';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { publicAPI } from '../../services/api';
import { generateImageUrl } from '../../utils/helpers';
import SectionHeader from '../common/SectionHeader';
import LoadingSpinner from '../common/LoadingSpinner';
import './FeaturedProjects.css';

const FeaturedProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ref, isVisible] = useScrollAnimation();

  useEffect(() => {
    publicAPI.getFeaturedProjects()
      .then(res => { if (res.success) setProjects(res.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="section featured-section" ref={ref}>
      <div className="container">
        <SectionHeader title="Featured Projects" subtitle="Projects that showcase my skills and experience" />
        {loading ? <LoadingSpinner /> : (
          <div className={`featured-grid ${isVisible ? 'fade-in' : ''}`}>
            {projects.map((project, i) => (
              <div key={project.id} className="featured-card card">
                <div className="featured-image">
                  <img src={generateImageUrl(project.thumbnailUrl)} alt={project.title} />
                  <div className="featured-overlay">
                    <Link to={`/projects/${project.slug}`} className="btn btn-primary">View Details</Link>
                  </div>
                </div>
                <div className="featured-body">
                  <div className="featured-tech">
                    {project.technologies?.split(',').slice(0, 3).map(tech => (
                      <span key={tech} className="tech-badge">{tech.trim()}</span>
                    ))}
                  </div>
                  <h3>{project.title}</h3>
                  <p>{project.shortDescription}</p>
                  <div className="featured-links">
                    {project.githubUrl && (
                      <a href={project.githubUrl} target="_blank" rel="noreferrer" className="project-link">
                        <FiGithub /> Code
                      </a>
                    )}
                    {project.liveDemoUrl && (
                      <a href={project.liveDemoUrl} target="_blank" rel="noreferrer" className="project-link">
                        <FiExternalLink /> Live Demo
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="text-center" style={{ marginTop: '40px' }}>
          <Link to="/projects" className="btn btn-outline">
            View All Projects <FiChevronRight />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
